<template>
  <div id="head">
    <!-- top -->
    <div class="top-out">
      <div class="top con">
        <span @click="SpanClick('zh-CN')" :class="lang==='zh-CN'?'red':''">简体中文</span> &nbsp; &nbsp; | &nbsp; &nbsp;
        <span @click="SpanClick('en-US')" :class="lang==='en-US'?'red':''">English</span> &nbsp; &nbsp; | &nbsp; &nbsp;
        <span @click="SpanClick('zang')" :class="lang==='zang'?'red':''">༄༅་། སློབ་ཚན་བདུན་པ་། བོད་ཡིག་</span> &nbsp; &nbsp;
        <span>{{PhoneNumber}}</span>
      </div>
    </div>

    <div id="menu" class="menu-wrap">
      <div class="con con1">
        <!-- logo -->
        
        <!-- pc导航栏 -->
        <div class="pctop">
          <router-link class="logo" to="/home">
            <img src="@/image/logo.png" >
          </router-link>
          <div class="menu">
            <div class="nav">
              <ul class="nav-ul">
                <!-- 首页 -->
                <li class="nav-li">
                  <router-link tag="div" class="nav-first" :class="{'ClickClass': $route.path === '/home'}" to="/home" >{{$t("home")}}</router-link>
                </li>
                <!-- 医院简介 -->
                <li class="nav-li">
                  <router-link tag="div" class="nav-first" to="/hosintro"  :class="{'ClickClass': $route.path === '/hosintro' || $route.path === '/hosnav'}" >{{$t("hosintro")}}</router-link>
                  <ul>
                    <div class="secondwrap">
                      <router-link tag="li" to="/hosnav" >{{$t("routenav")}}</router-link>
                    </div>
                  </ul>
                </li>
                <!-- 科室导航 -->
                <li class="nav-li">
                  <router-link tag="div" class="nav-first" to="/departmentintro"  :class="{'ClickClass': $route.path === '/departmentintro'  || $route.path === '/firstdepart' || $route.path === '/departmentdetail'}" >{{$t("departmentnav")}}</router-link>
                  <ul>
                    <div class="secondwrap">
                      <router-link v-for="(item,index) in firstDepart" tag="li" :to="'/firstdepart?id=' + item.ID"  :key="index">{{item.DeptName}}</router-link>
                    </div>
                  </ul>
                </li>
                <!-- 专家介绍 -->
                <li class="nav-li">
                  <router-link tag="div" class="nav-first" to="/experts" :class="{'ClickClass': $route.path === '/experts' || $route.path === '/expertsdetail'}" >{{$t("expertintro")}}</router-link>
                </li>
                <!-- 医院动态 -->
                <li class="nav-li">
                  <router-link tag="div" class="nav-first" to="/hosdynamic"  :class="{'ClickClass': $route.path === '/hosdynamic' || $route.path === '/news' || $route.path === '/notice' || $route.path === '/newscenter' || $route.path === '/media' || $route.path === '/opentender' || $route.path === '/newsdetail' || $route.path === '/tenderdetail'}" >{{$t("hosdynamic")}}</router-link>
                  <ul>
                    <div class="secondwrap">

                    <li v-for="(item,index) in hosDynamic" :key="index"><router-link tag="li" :to="'/news?id=' + item.TypeCode + '&typename=' + item.TypeName + '&ShowTypeID=' + item.ShowTypeID " >{{item.TypeName}}</router-link></li>

                    </div>
                  </ul>
                </li>
                <!-- 预约挂号 -->
                <!-- <li class="nav-li">
                  <router-link tag="div" class="nav-first" to="/appointment" :class="{'ClickClass': $route.path === '/appointment'}" >{{$t("appointment")}}</router-link>
                </li> -->
                <!-- 加入我们 -->
                <li class="nav-li">
                  <router-link tag="div" class="nav-first" to="/joinus" :class="{'ClickClass': $route.path === '/joinus' || $route.path === '/job' || $route.path === '/jobdetail'}" >{{$t("joinus")}}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <router-link class="logo logo2" to="/home">
          <img src="@/image/logo.png" >
        </router-link>
        <!-- 按钮 -->
        <button class="line3" @click="mobilenavshow = !mobilenavshow"><i class="dk">&#xe630;</i></button>
        <!-- 移动端导航 -->
        <div class="mobile-nav" v-show="mobilenavshow">
          <ul >
              <!-- 首页 -->
              <li>
                <router-link  class="nav-first"  to="/home" >{{$t("home")}}</router-link>
              </li>
              <!-- 医院简介 -->
              <li>
                <router-link  class="nav-first" to="/hosintro" >{{$t("hosintro")}}</router-link>
                <button @click="showli('hosintro')"><i class="dk" v-html="lishow === 'hosintro'? '&#xe6b8;':'&#xe6b9;' "></i></button>
                <ul v-if="lishow === 'hosintro'">
                    <router-link tag="li" to="/hosnav" >{{$t("routenav")}}</router-link>
                </ul>
              </li>
              <!-- 科室导航 -->
              <li>
                <router-link  class="nav-first" to="/departmentintro"  >{{$t("departmentnav")}}</router-link>
                <button @click="showli('departmentintro')"><i class="dk" v-html="lishow === 'departmentintro'? '&#xe6b8;':'&#xe6b9;' "></i></button>
                <ul v-if="lishow === 'departmentintro'">
                    <router-link v-for="(item,index) in firstDepart" tag="li" :to="'/firstdepart?id=' + item.ID" :key="index">{{item.DeptName}}</router-link>
                </ul>
              </li>
              <!-- 专家介绍 -->
              <li>
                <router-link  class="nav-first" to="/experts">{{$t("expertintro")}}</router-link>
              </li>
              <!-- 医院动态 -->
              <li>
                <router-link  class="nav-first" to="/hosdynamic" >{{$t("hosdynamic")}}</router-link>
                <button @click="showli('hosdynamic')"><i class="dk" v-html="lishow === 'hosdynamic'? '&#xe6b8;':'&#xe6b9;' "></i></button>
                <ul v-if="lishow === 'hosdynamic'">
                  <li v-for="(item,index) in hosDynamic" :key="index"><router-link tag="li" :to="'/news?id=' + item.TypeCode + '&typename=' + item.TypeName + '&ShowTypeID=' + item.ShowTypeID">{{item.TypeName}}</router-link></li>
                </ul>
              </li>
              <!-- 预约挂号 -->
              <!-- <li>
                <router-link  class="nav-first" to="/appointment">{{$t("appointment")}}</router-link>
              </li> -->
              <!-- 加入我们 -->
              <li>
                <router-link  class="nav-first" to="/joinus" >{{$t("joinus")}}</router-link>
              </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getDoc,getHosDynamic,getContact} from '@/api/api'
export default {
  data () {
    return {
      lang: sessionStorage.getItem('language'),
      lishow: '',
      mobilenavshow : false,
      firstDepart: [],
      hosDynamic: [],
      PhoneNumber: ''
    }
  },
  methods: {
    // 语言切换
    SpanClick (lang) {
      this.LanChange(lang)
      this.WeightChange()
    },
    LanChange (lang) {
      this.$i18n.locale = lang;
      sessionStorage.setItem('language', lang)
      if (lang === 'zh-CN') {
        sessionStorage.setItem('lang', 1)
        this.getFirstDepart(1)
        this.getDynamic(2 , 1)
        this.getContact(1)
      } else if (lang === 'en-US') {
        sessionStorage.setItem('lang', 2)
        this.getFirstDepart(2)
        this.getDynamic(39, 2)
        this.getContact(2)
      } else {
        sessionStorage.setItem('lang', 3)
        this.getFirstDepart(3)
        this.getDynamic(43, 3)
        this.getContact(3)
      }
      this.lang = lang
    },
    positionul(i){
          var navFirst = document.getElementsByClassName('nav-first');
          var width = navFirst[i].offsetWidth;
          navFirst[i].nextSibling.nextSibling.style.left = (width - 240)/2 + 'px';
    },
    WeightChange(){
      this.$nextTick(() => {
        this.positionul(1)
        this.positionul(2)
        this.positionul(4)
      })
    },
    showli(ul){
      if(this.lishow == ul){
        this.lishow = ''
      }else {
        this.lishow = ul
      }
    },
    async getFirstDepart(lang){
      let res = await getDoc(lang);
      let {Head,Content} = res.data;
        if (Head.Ret == 0) {
          this.firstDepart = Content.Items
        }
    },
    async getDynamic(TypeID ,lang){
        let res = await getHosDynamic(TypeID, lang);
        let {Head,Content} = res.data;
        if (Head.Ret == 0) {
          this.hosDynamic = res.data.Content
        }
    },
    async getContact(lang){
      let res = await getContact(lang);
      let {Head,Content} = res.data;
        if (Head.Ret == 0) {
          this.PhoneNumber = Content.Item[0].PhoneNumber
        }
    },
  },
  mounted(){
    //获取父级科室类别
    this.getFirstDepart(sessionStorage.getItem('lang'))
    this.getContact(sessionStorage.getItem('lang'))
    //获取 新闻类别
    let lang = sessionStorage.getItem('lang')
    if (lang == 1) {
      this.getDynamic(2, lang)
    } else if (lang == 2) {
      this.getDynamic(39, lang)
    } else if (lang == 3) {
      this.getDynamic(43, lang)
    }
    
    var that = this;
    // console.log(this, 'this')
    this.$nextTick(async () => {
      await that.positionul(1)
      await that.positionul(2)
      await that.positionul(4)
    })
      
  },
  watch: {
    $route(){
       this.mobilenavshow = false;
    }
  }
}
</script>
<style lang="scss">
</style>

<style scoped lang="scss">
#head{
  width: 100%;
  position: relative;
  .top-out {
    width:100%;
    background: #01763a;
    .top {
      //width:1230px;
      background: #01763a!important;
      margin:0 auto;
      height: 32px;
      line-height: 32px;
      text-align: right;
      color : #fff;
      span {
        font-size: 14px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  
  .menu-wrap {
    width: 100%;
    background: #fff;
    &>div {
      margin: 0 auto;
      text-align: center;
      &:after {
        content: '';
        display: table;
        clear: both;
      }
    }
    .pctop {
      min-width: 1200px;
      display: inline-block;
      text-align: left;
    }
    .logo {
      height: 100px;
      width: 100px;
      // display:block;
      // float: left;
      display: inline-block;
      img {
        margin-top: 10px;
        height: 80px;
        // width: 100px;
        width: auto;
        display: inline-block;
      }
    }
    .logo2 {
      display: none;
    }
    .menu {
      display: inline-block;
      margin-left: 50px;
      // width: calc(100% - 130px);
      .nav {
        //width:1100px;
        display: inline-block;
        float: left;
        .nav-ul {
          li {
            cursor: pointer;
          }
          .nav-li {
            display: inline-block;
            position: relative;
            margin-top:50px;
            .nav-first {
              border-radius: 20px;
              text-align: center;
              line-height: 40px;
              // width:102px;
              // height:40px;
              padding: 0 20px;
            }
            .ClickClass {
              background: #01763a;
              color: #fff;
            }
            ul {
              width: 240px;
              position: absolute;
              z-index: 800;
              top: 40px;
              left: -60px;
              padding: 15px 0 5px;
              display: none;
              // background: rgba(255, 255, 255, .8);
              // background: rgba(0,120,63,.7);
              .secondwrap {
                //margin: 1px 0;
                background: rgba(0,120,63,.7);
              }
              li {
                white-space: nowrap;
                height:40px;
                line-height: 40px;
                line-height:30px;
                padding: 0 10px;
                color: #fff;
                text-align: center;
              }
            }
          }
          .nav-li:hover .nav-first {
            background: #01763a;
            color: #fff;
          }
          .nav-li:hover ul {
             display: block;
             color: #888888;
          }
          .nav-li ul li:hover {
            color: #fff;
            //background: rgba(74, 127, 219, .8);
            background: rgba(0,120,63,.8)
          }
        }
      }
    }
    .line3 {
      display:none;
      float: right;
      width: 100px;
      height: 100px;
      border: none;
      outline: none;
      background: #fff;
      i {
         font-size: 40px;
          color: #00783F;
      }
    }
    .mobile-nav {
      clear:both;
       //position: relative;
       position: absolute;
       z-index: 9;
       width: 100%;
       opacity: .98;
       margin-top: 50px;
       &>ul {
         background: #fff;
         text-indent: 2em;
         a {
           display:block;
           color: #333;
         }
         &>li {
           font-size: 20px;
           font-size: 0.16rem;
           line-height: 2;
           margin-top: 10px;
           //height: 60px;
           a {
             width: 75%;
             float: left;
           }
           button {
             display: block;
             float: right;
             border: none;
             margin-right: 10%;
            // height: 40px;
             height: 0.32rem;
             width: 40px;
             background: #fff;
             outline: none;
            // margin-top: 10px;
            
             i {
               font-size: 40px;
               color: #4DC15A;
               line-height: 0.32rem
             }
           }
           &:hover {
             a {
               background: #00783F ;
             }
             a {
                color: #fff;
             }
           }
           &>ul{
             clear: both;
             margin-top: 10px;
             &>li {
               width: 70%;
               margin-left: 15%;
               color: #00783F;
               line-height: 2;
               margin-top: 10px;
               cursor: pointer;
               &:hover {
                 background: #00783F;
                 color: #fff;
               }
             }
           }
           &:after {
             content: '';
             display: table;
             clear: both;
           };
         }
       }
    }
  }
  &:after {
    content: '';
    display: table;
    clear: both;
  };
}
.red {
  color: #ee8e17;
}

@media (max-width: 1200px) {
  #head {
    .top {
      overflow: hidden;
      span:last-child {
        display: none;
      }
    }
    .menu-wrap {
      .pctop {
        display: none;
      }
      .logo {
        display: block;
        height: 50px;
        width: 50px;
        float: left;
        img {
          margin-top: 0;
          height: 100%;
          width: auto;
        }
      }
    }
    .line3 {
      display: inline-block!important;
      height: 50px !important;
      i {
        height: 50px !important;
      }
    }
  }
}
@media (min-width: 1200px) {
  .con1 {
    width: auto;
    min-width: 1200px
  }
}

</style>




// WEBPACK FOOTER //
// src/components/Head.vue